export default __webpack_public_path__ + "static/media/Dive2.8f87f7b7.png";